import * as types from "./actionTypes";
import { AppThunk } from "./AppThunk";
import Fullscreen from "react-full-screen";

export function setFullScreen(fullscreen: boolean): AppThunk {
    return function (dispatch, getState) {
        dispatch(fullScreenUpdated(fullscreen));
    };
}

function fullScreenUpdated(fullscreen: boolean) {
    return {
        type: types.FULLSCREEN_UPDATED as typeof types.FULLSCREEN_UPDATED,
        fullscreen,
    };
}

export function setFullscreenContainer(container: Fullscreen | null): AppThunk {
    return function (dispatch, getState) {
        dispatch(setFullscreenContainerComplete(container));
    };
}

const setFullscreenContainerComplete = (container: Fullscreen | null) => ({
    type: types.SET_FULLSCREEN_CONTAINER as typeof types.SET_FULLSCREEN_CONTAINER,
    container,
});

export type UXActions = ReturnType<typeof fullScreenUpdated> | ReturnType<typeof setFullscreenContainerComplete>;
